/*

& team_invite: the default (empty) pending team invite; filled by fetchTeamInviteThunk on
& the `/?invite=<token>` home page.

*/

import StateInterface from "../state-interface";

export const team_invite: StateInterface["team_invite"] = {
	_id: "",
	team_name: "",
	team_display_picture: "",
	role: "",
	permission_description: "",
	status: "",
	business_profile_id: "",
	modules: [],
	owned_business: null,
	current_team: null,
	new_team: null,
};
